/* eslint-disable no-param-reassign */
import * as MultipleChoiceResponseUtils from '../response/multipleChoiceStep';
import * as YesOrNoResponseUtils from '../response/yesOrNoStep';
import * as ChoiceStepUtils from '../userTest/choiceStepUtils';
import * as MultipleChoiceStepUtils from '../userTest/multipleChoiceStep';
import { getAllSteps } from '../userTest/selectors';
import * as StepUtils from '../userTest/stepUtils';
import { StepClass, } from '../userTest/types';
import * as YesOrNoStepUtils from '../userTest/yesOrNoStep';
export function getConditionalNextStepUUID(step, response) {
    var _a, _b;
    if (step.className === StepClass.YesOrNo &&
        response.className === StepClass.YesOrNo) {
        const answer = YesOrNoResponseUtils.getAnswer(response);
        return YesOrNoStepUtils.getConditionalNextStepUUID(step, answer);
    }
    if ((step.className === StepClass.MultipleChoice &&
        response.className === StepClass.MultipleChoice) ||
        (step.className === StepClass.PreferenceTest &&
            response.className === StepClass.PreferenceTest) ||
        (step.className === StepClass.TaglineCopyTest &&
            response.className === StepClass.TaglineCopyTest)) {
        const answer = MultipleChoiceResponseUtils.getAnswer(response);
        return MultipleChoiceStepUtils.getConditionalNextStepUUID(step, answer);
    }
    if (!('conditions' in step))
        return null;
    return (_b = (_a = step.conditions) === null || _a === void 0 ? void 0 : _a.ALWAYS) !== null && _b !== void 0 ? _b : null;
}
export const getHasConditionalLogicSet = (steps) => {
    const stepWithConditionalLogic = steps.find((step) => {
        var _a, _b, _c, _d;
        if (StepUtils.isOfType(step, StepClass.MediaSettings) || !step.conditions) {
            return false;
        }
        if (StepUtils.isOfType(step, StepClass.YesOrNo)) {
            return !!(((_a = step.conditions) === null || _a === void 0 ? void 0 : _a.ALWAYS) ||
                ((_b = step.conditions) === null || _b === void 0 ? void 0 : _b.answer.true) ||
                ((_c = step.conditions) === null || _c === void 0 ? void 0 : _c.answer.false));
        }
        if (StepUtils.isChoiceStep(step)) {
            return !!(((_d = step.conditions) === null || _d === void 0 ? void 0 : _d.rules.length) || step.conditions.ALWAYS);
        }
        return !!step.conditions.ALWAYS;
    });
    return !!stepWithConditionalLogic;
};
export function getIsChoiceConditional(step, uuid) {
    var _a, _b;
    // check if step has conditional logic set
    const hasConditionalLogicSet = !!((_a = step.conditions) === null || _a === void 0 ? void 0 : _a.rules.length);
    if (hasConditionalLogicSet) {
        // check each rule for deletedUUID
        return !!((_b = step.conditions) === null || _b === void 0 ? void 0 : _b.rules.find((rule) => {
            return rule.requirements.find((requirement) => {
                return requirement.selectedChoiceUUID === uuid;
            });
        }));
    }
    return false;
}
export function getIsDeletedStepConditional(mutable, deletedStepUUID) {
    const steps = getAllSteps(mutable);
    return !!steps.find((step) => {
        if (StepUtils.isOfType(step, StepClass.MediaSettings))
            return false;
        if (step.conditions) {
            if (step.conditions.ALWAYS === deletedStepUUID) {
                return true;
            }
            if (StepUtils.isChoiceStep(step)) {
                return !!step.conditions.rules.find(({ destinationStepUUID }) => destinationStepUUID === deletedStepUUID);
            }
            if (StepUtils.isOfType(step, StepClass.YesOrNo)) {
                if (step.conditions.answer.true === deletedStepUUID) {
                    return true;
                }
                if (step.conditions.answer.false === deletedStepUUID) {
                    return true;
                }
            }
        }
        return false;
    });
}
export function deleteChoiceRules(mutable, deletedChoiceUUID) {
    var _a;
    if (!mutable.conditions) {
        ChoiceStepUtils.addEmptyRulesObject(mutable);
    }
    else {
        // filter out any rules that are associated with the deleted choice
        const filteredRules = (_a = mutable.conditions) === null || _a === void 0 ? void 0 : _a.rules.filter((rule) => {
            return !rule.requirements.find((req) => req.selectedChoiceUUID === deletedChoiceUUID);
        });
        mutable.conditions.rules = filteredRules;
    }
}
export function deleteAssociatedStepRules(mutable, deletedStepUUID) {
    const steps = getAllSteps(mutable);
    steps.forEach((step) => {
        if (StepUtils.isOfType(step, StepClass.MediaSettings))
            return false;
        if (step.conditions) {
            if (step.conditions.ALWAYS === deletedStepUUID) {
                step.conditions.ALWAYS = null;
            }
            if (StepUtils.isChoiceStep(step)) {
                step.conditions.rules.forEach(({ destinationStepUUID }, index) => {
                    if (destinationStepUUID === deletedStepUUID) {
                        ChoiceStepUtils.deleteConditionalRule(step, index);
                    }
                });
            }
            if (StepUtils.isOfType(step, StepClass.YesOrNo)) {
                if (step.conditions.answer.true === deletedStepUUID) {
                    step.conditions.answer.true = null;
                }
                if (step.conditions.answer.false === deletedStepUUID) {
                    step.conditions.answer.false = null;
                }
            }
        }
    });
}
export function getRules(step) {
    if (!step.conditions) {
        ChoiceStepUtils.addEmptyRulesObject(step);
        return [];
    }
    return step.conditions.rules.filter((rule) => rule.destinationStepUUID !== null);
}
export function getAlwaysUUID(step) {
    var _a, _b;
    return (_b = (_a = step.conditions) === null || _a === void 0 ? void 0 : _a.ALWAYS) !== null && _b !== void 0 ? _b : null;
}
